<div class="page-layout-container">
  <div class="page-header">
    <div>
      <h1 class="title">Asset History</h1>
      <p class="subtitle">
        Track asset assignment and status changes over time
      </p>
    </div>
  </div>

  <div class="search-card">
    <div class="search-section">
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Search Asset ID</mat-label>
        <input
          matInput
          (keyup)="searchAsset($event)"
          placeholder="Enter asset ID to view history"
        />
        <mat-hint>Enter the asset ID to retrieve its history</mat-hint>
      </mat-form-field>
    </div>
  </div>
  <div class="asset-summary-card" *ngIf="searchPerformed">
    <div class="results-info">
      <p class="results-text">Assets Details</p>
    </div>
    <!-- Group 1 -->
    <div class="summary-field">
      <div class="summary-label">Asset Type</div>
      <div class="summary-value">{{ assetType || "Not Set" }}</div>
    </div>

    <!-- Group 2 -->
    <div class="summary-field">
      <div class="summary-label">Make</div>
      <div class="summary-value">{{ make || "Not Set" }}</div>
    </div>

    <div class="summary-field">
      <div class="summary-label">Number</div>
      <div class="summary-value">{{ model || "Not Set" }}</div>
    </div>
  </div>
  <div class="table-card" *ngIf="searchPerformed">
    <div class="results-info">
      <p class="results-text">{{ assetHistryList.length }} record(s) found</p>
    </div>

    <div class="table-responsive">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="assetAssignedToEmp">
          <th mat-header-cell *matHeaderCellDef>Assigned To</th>
          <td mat-cell *matCellDef="let element">
            {{ element.assetAssignedToEmp }}
          </td>
        </ng-container>

        <ng-container matColumnDef="empAssignedDate">
          <th mat-header-cell *matHeaderCellDef>Start Date</th>
          <td mat-cell *matCellDef="let element">
            {{ element.empAssignedDate | date: "dd/MMM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="empEndDate">
          <th mat-header-cell *matHeaderCellDef>End Date</th>
          <td mat-cell *matCellDef="let element">
            {{ element.empEndDate | date: "dd/MMMM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">{{ element.status }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <mat-paginator
        [pageSizeOptions]="[5, 10, 20]"
        showFirstLastButtons
        aria-label="Select page of asset history"
      >
      </mat-paginator>
    </div>

    <div class="empty-state" *ngIf="assetHistryList.length === 0">
      <mat-icon>info</mat-icon>
      <p>No history found for this asset ID</p>
    </div>
  </div>
</div>
